module.exports = __webpack_public_path__ + "img/tie.007207ac.svg";